import http, { API_PREFIX } from '@/services/http'

export const videosApi = {
  status() {
    return http.get(`${API_PREFIX}/videos/status`)
  },
  list(params?: { offset?: number; limit?: number; linked_type?: string; linked_id?: string }) {
    return http.get(`${API_PREFIX}/videos/`, { params })
  },
  generate(prompt: string, duration: number = 5, width?: number, height?: number) {
    const payload: any = { prompt, duration }
    if (width !== undefined) payload.width = width
    if (height !== undefined) payload.height = height
    return http.post(`${API_PREFIX}/videos/generate`, payload)
  },
  getMeta(id: string) {
    return http.get(`${API_PREFIX}/videos/${id}`)
  },
  link(id: string, linked_type: string | null, linked_id?: string | null, linked_is_primary?: boolean) {
    const body: any = { linked_type, linked_id }
    if (typeof linked_is_primary !== 'undefined') body.linked_is_primary = linked_is_primary
    return http.put(`${API_PREFIX}/videos/${id}/link`, body)
  },
  fileUrl(id: string) {
    const base = (typeof window !== 'undefined') ? ( (typeof (http as any).defaults?.baseURL === 'string') ? (http as any).defaults.baseURL : '' ) : ''
    if (base) {
      const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base
      return `${trimmedBase}${API_PREFIX}/videos/${id}/file`
    }
    return `${API_PREFIX}/videos/${id}/file`
  },
  getModels(params?: { q?: string; provider_id?: string }) {
    return http.get(`${API_PREFIX}/videos/models`, { params })
  },
  createModel(data: { model_id: string; name: string; description?: string; price?: number }) {
    return http.post(`${API_PREFIX}/videos/models`, data)
  },
  updateModel(modelId: string, data: { name?: string; description?: string; price?: number }) {
    return http.put(`${API_PREFIX}/videos/models/${modelId}`, data)
  },
  deleteModel(modelId: string) {
    return http.delete(`${API_PREFIX}/videos/models/${modelId}`)
  },
  getUsageStatistics(days?: number) {
    return http.get(`${API_PREFIX}/videos/usage/statistics`, { params: { days } })
  },
  getRecentRequests(limit = 25) {
    return http.get(`${API_PREFIX}/videos/usage/recent`, { params: { limit } })
  }
}